import AddTeam from '../AddTeam';

const AddGroup = () => {
  return <AddTeam type='group' />;
};

export default AddGroup;
